import React from "react";

const notFound = () => (
  <div>
    <h2>Not Found?!?!?!?</h2>
  </div>
);
export default notFound;
